import { useCallback } from 'react';

import { useDeleteModelMutation } from './__generated__/mutations.generated';

export default function useDeleteModel(): (modelId: string) => Promise<void> {
  const [deleteModelMutation] = useDeleteModelMutation();

  return useCallback(
    async (modelId: string) => {
      await deleteModelMutation({
        variables: { modelId },
      });
    },
    [deleteModelMutation],
  );
}
